<template>
  <page>
    <template slot="content">
      <help-content :title="'WeRUNアプリが使えない機種はありますか？'">
        <template slot="content">
          <div class="text">ほとんどのスマホは問題なくご利用いただけます。動作確認済みの機種は以下の通りです。<br>・iOS8以上（iPhone5S以後の機種）<br>・Android6以上<br>※サポート対象外機種：Xperia SO-04H</div>
        </template>
      </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help1.vue